module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/components/ClanLandingReserves/images/background-sm.26cb4408.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/components/ClanLandingReserves/images/background-sm.png
// module id = 2928
// module chunks = 11